import React, { lazy } from 'react'
const AuthRoutes = lazy(() => import('../auth'))

export const publicRoutes = [
  {
    path: '/*',
    element: <AuthRoutes />
  }
]